/* eslint-disable jsx-a11y/alt-text */
import Head from "next/head";
import styles from "./blog.module.css";
import Image from "next/image";
import heroImage from "../../public/img/blog-library.png";

export default function Library() {
  return (
    <main>
      <Head>
        <title>Virna | Discover the Magic of Children&apos;s Books: A Library of Timeless Stories for Young Minds</title>
      </Head>
      <div className={styles.hero}>
        <Image
          className={styles.heroImage2}
          style={{ objectFit: "cover" }}
          src={heroImage}
          alt="Picture of a child's library"
          fill
        />
      </div>
      <div className={`main ${styles.main}`} style={{background: "#438092"}}>
        <article>
          <h1>A Library of Timeless Stories for Young Minds</h1>
          <div className={styles.meta}>Development | April 27, 2023 | by Soraya Dib</div>
          <p>
            Welcome to Virna&apos;s library, where you will find an incredible collection of children&apos;s books that have stood the test of time. I am proud to offer a wide selection of
            classic and modern stories that will ignite the imagination and spark the love of reading in young minds. From picture books that introduce basic concepts like colors
            and numbers, to stories that teach valuable life lessons like friendship, empathy, and perseverance, my library has something for every child. Whether you are a parent,
            a teacher, or a child who loves to read, I invite you to discover the magic of these beloved stories that have captivated generations of young readers.
          </p>

          <div className={styles.blogProductsStacked}>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780316012492" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780316012492.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780316012492">&ldquo;The Feelings Book&rdquo; by Todd Parr</a> introduces kids to a wide range of emotions and feelings. It uses colorful
                illustrations and simple language to help children understand and identify their own emotions and those of others.
              </p>
            </div>

            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780670012336" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780670012336.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780670012336">&ldquo;Llama Llama Time to Share&rdquo; by Anna Dewdney</a> is about a young llama who has trouble sharing his toys with
                his friends. Through the story, the book teaches children about the importance of sharing and the positive feelings that come with it.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780439856546" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780439856546.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780439856546">&ldquo;How Do Dinosaurs Play with Their Friends?&rdquo; by Jane Yolen and Mark Teague</a> uses dinosaurs to teach kids
                about good social behavior. It shows examples of how dinosaurs share, take turns, and apologize when they make mistakes.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781575422008" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781575422008.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781575422008">&ldquo;Hands Are Not for Hitting&rdquo; by Martine Agassi</a> teaches kids about the importance of using their hands in a
                positive way. It shows examples of how hands can be used to help others and solve problems, rather than hurt or harm them.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780439851473" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780439851473.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780439851473">&ldquo;Grumpy Bird&rdquo; by Jeremy Tankard</a> is about a bird who wakes up feeling grumpy and goes for a walk to try and
                shake it off. Along the way, he meets other animals who try to cheer him up. The book teaches children about emotions and how they can change over time.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780374360979" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780374360979.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780374360979">&ldquo;The Pout-Pout Fish&rdquo; by Deborah Diesen</a> is about a fish who thinks he is always doomed to be sad and pouty.
                But through the story, he learns that he can change his attitude and outlook on life, and that he can be happy and have fun.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781933718002" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781933718002.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781933718002">&ldquo;The Kissing Hand&rdquo; by Audrey Penn</a>is about a young raccoon who is nervous about starting school. His mother
                gives him a &ldquo;kissing hand&rdquo; to remind him that she loves him and is always with him, even when they are apart.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780062983374" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780062983374.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780062983374">&ldquo;Chrysanthemum&rdquo; by Kevin Henkes</a>is about a young mouse named Chrysanthemum who loves her name until she
                starts school and gets teased&rdquo; by other kids for it. The book teaches children about self-acceptance and the importance of being kind to others.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781558585362" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781558585362.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781558585362">&ldquo;The Rainbow Fish&rdquo; by Marcus Pfister</a>is about a beautiful fish who learns to share his sparkling scales with
                others, even though it is hard for him to do so. The book teaches children about the joy of giving and the importance of sharing.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781338299588" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781338299588.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781338299588">&ldquo;No, David!&rdquo; by David Shannon</a>is about a mischievous boy named David who gets into trouble for breaking
                rules and causing chaos. The book teaches children about the consequences of their actions and the importance of following rules.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780451470799" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780451470799.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780451470799">&ldquo;Corduroy&rdquo; by Don Freeman</a>is about a teddy bear named Corduroy who goes on a quest to find his missing
                button. The book teaches children about the value of perseverance and friendship.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780399226908" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780399226908.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780399226908">&ldquo;The Very Hungry Caterpillar&rdquo; by Eric Carle</a>is about a caterpillar who eats his way through various foods
                until he transforms into a butterfly. The book teaches children about the life cycle of butterflies and the importance of healthy eating.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780439598453" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780439598453.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780439598453">&ldquo;When Sophie Gets Angry – Really, Really Angry…&rdquo; by Molly Bang</a>is about a young girl named Sophie who
                becomes very angry and goes for a walk to calm down. The book teaches children about emotions and how to deal with them in a healthy way.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780689859861" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780689859861.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780689859861">&ldquo;Bear Feels Scared&rdquo; by Karma Wilson</a>is about a bear who is scared during a storm and finds comfort from his
                forest animal friends. This book teaches children about the importance of friendship, empathy, and how to comfort someone who is scared.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780316450010" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780316450010.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780316450010">&ldquo;The Color Monster: A Story About Emotions&rdquo; by Anna Llenas</a> explores different emotions through the story of
                a monster who tries to sort out his mixed-up emotions with the help of a little girl. This book teaches children about identifying and managing their emotions in a
                healthy way.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780545392556" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780545392556.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780545392556">&ldquo;Giraffes Can&apos;t Dance&rdquo; by Giles Andreae</a> follows the journey of a giraffe named Gerald who learns to dance
                with the help of a cricket. This book teaches children about perseverance, self-confidence, and how to overcome their fears.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780316111539" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780316111539.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780316111539">&ldquo;How to Be a Friend: A Guide to Making Friends and Keeping Them&rdquo; by Laurie Krasny Brown and Marc Brown</a>{" "}
                offers practical advice on making and keeping friends, with tips on things like sharing, listening, and apologizing. This book teaches children social skills such
                as listening, sharing, and respecting others, and how to build and maintain healthy friendships.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780064433488" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780064433488.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780064433488">&ldquo;Leo the Late Bloomer&rdquo; by Robert Kraus</a>is about a young lion named Leo who struggles to keep up with his
                peers until he eventually blossoms in his own time. This book teaches children about patience, self-esteem, and the importance of not comparing oneself to others.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780679893448" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780679893448.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780679893448">&ldquo;My Many Colored Days&rdquo; by Dr. Seuss</a> explores emotions through the use of colors, with each color
                representing a different mood or feeling. This book teaches children about different emotions and how to express them in a healthy way.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781884734717" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781884734717.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781884734717">&ldquo;The Way I Feel&rdquo; by Janan Cain</a> uses vivid illustrations and simple language to help children understand and
                express their emotions and manage them in a healthy way.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780694003617" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780694003617.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780694003617">&ldquo;Goodnight Moon&rdquo; by Margaret Wise Brown</a> follows a bunny saying goodnight to everything in his room before
                drifting off to sleep. This book teaches children about the importance of bedtime routines and getting a good night&apos;s sleep.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780064431781" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780064431781.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780064431781">&ldquo;Where the Wild Things Are&rdquo; by Maurice Sendak</a> tells the story of a young boy named Max who travels to a
                land of wild creatures, becoming their king before eventually returning home. This book teaches children about the importance of using their imaginations, and how
                to express their emotions in a healthy way.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780805047905" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780805047905.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780805047905">&ldquo;Brown Bear, Brown Bear, What Do You See?&rdquo; by Bill Martin Jr.</a> uses repetitive phrases and colorful
                illustrations to help young children learn about animals and colors and introduces pattern recognition.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780394800011" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780394800011.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780394800011">&ldquo;The Cat in the Hat&rdquo; by Dr. Seuss</a> follows the mischievous Cat in the Hat as he visits two bored children
                and causes chaos in their home. It teaches the importance of following rules and being responsible, and how to have fun within appropriate boundaries.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781536210637" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781536210637.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781536210637">&ldquo;Guess How Much I Love You&rdquo; by Sam McBratney</a> is a sweet and tender story about a young hare and his father
                who try to express their love for each other. This book teaches children about expressing love and affection for others.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781442450707" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781442450707.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781442450707">&ldquo;Chicka Chicka Boom Boom&rdquo; by Bill Martin Jr. and John Archambault</a> uses a catchy rhythm and colorful
                illustrations to teach children about the alphabet.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9781416947370" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9781416947370.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9781416947370">&ldquo;Dear Zoo&rdquo; by Rod Campbell</a> is a lift-the-flap book about a child who writes to the zoo asking for a pet,
                receiving a series of increasingly unsuitable animals in response. It teaches children about animals and the concept of making choices.
              </p>
            </div>
            <div className={styles.blogProduct}>
              <a href="https://bookshop.org/a/93429/9780395150238" className={styles.caption}>
                <img className={styles.blogProductImage} src="https://images-us.bookshop.org/ingram/9780395150238.jpg?height=300&v=v2" />
              </a>
              <p>
                <a href="https://bookshop.org/a/93429/9780395150238">&ldquo;Curious George&rdquo; by H.A. Rey</a> introduces the beloved character of Curious George, a monkey who gets into all
                sorts of adventures and mischief. This book teaches children about curiosity, problem-solving, and the consequences of their actions.
              </p>
            </div>
          </div>

          <p>
            Buying for a baby? Reading to an infant is a wonderful way to bond with your child and promote their cognitive and emotional development. Even though they may not
            understand the words yet, the sound of your voice and the rhythm of the story will capture their attention and stimulate their brain. As you read, your child will learn
            to associate books with positive emotions and enjoy the comforting routine of storytime. Additionally, reading to your infant is an opportunity to expose them to new
            sounds, words, and ideas, which can help expand their vocabulary, improve their communication skills, and build their knowledge about the world.{" "}
          </p>

          <p>
            You can start introducing these books and adapt your reading style to keep them engaged. Use simple language, point to the pictures, and discuss the emotions and
            situations in the story. As your child grows older, they will be able to better understand and appreciate the content of these books.
          </p>
        </article>
      </div>
      <aside className={styles.disclosure}>
        <div className={styles.content}>
          <p>Affiliate Disclosure</p>
          <p>
            Some of the links on this website are affiliate links, which means that we may earn a commission if you click on the link or make a purchase using the link. When you
            make a purchase, the price you pay will be the same whether you use the affiliate link or go directly to the vendor&apos;s website using a non-affiliate link.
          </p>
          <p>
            By using the affiliate links, you are supporting the website, and we genuinely appreciate your support. We only recommend products or services that we believe will add
            value to our readers. We strive to provide honest opinions and experiences, regardless of whether we earn a commission or not.
          </p>
          <p>
            Please note that we have not been given any free products, services or anything else by these companies in exchange for mentioning them on the site. The only
            compensation received is in the form of an affiliate commission.
          </p>
          <p>If you have any questions regarding the above, please do not hesitate to contact us.</p>
        </div>
      </aside>
    </main>
  );
}
